export type ImageUnionTypes = 'oneImage';

export enum ImageSize {
  custom = 'custom'
}

export enum ImageAlignment {
  top = 'top',
  right = 'right',
  left = 'left',
  bottom = 'bottom',
  center = 'center',
  custom = 'custom'
}
